import {all, takeLatest} from '@redux-saga/core/effects';
import {AsyncResult, fromResult, Loading, LoadingAdditional} from 'Core/models/Async';
import {Page} from 'Core/models/Page';
import * as E from 'fp-ts/lib/Either';
import {pipe} from 'fp-ts/lib/pipeable';
import {PolicyApplicationDto} from 'Agent/Policies/api';
import policyApi from 'Agent/Policies/api/policyApi';
import {
  changeApplications,
  getApplications,
  PolicyApplicationsActionType,
} from 'Agent/Policies/ducks/policyApplications';
import {call, put} from 'redux-saga/effects';
import {mergeWithNextPage} from 'Shared/utilities/PageUtility';

function* getPolicyApplicationsFromApi(action: ReturnType<typeof getApplications>) {
  if (action.payload.page) {
    yield put(changeApplications(new LoadingAdditional(action.payload.page)));
  } else {
    yield put(changeApplications(new Loading(action.payload.page)));
  }

  const result: AsyncResult<Page<PolicyApplicationDto>> = yield action.payload.page
    ? call(mergeWithNextPage, {existingPage: action.payload.page})
    : call(
        policyApi.getPolicyApplications,
        action.payload.encryptedIdentifier,
        action.payload.filter,
        action.payload.sort
      );

  yield pipe(
    result,
    E.map(fromResult),
    E.fold(
      value => put(changeApplications(value)),
      value => put(changeApplications(value))
    )
  );
}

export function* getPolicyApplicationsSaga() {
  yield takeLatest(PolicyApplicationsActionType.FETCH_APPLICATIONS, getPolicyApplicationsFromApi);
}

export default function*() {
  yield all([getPolicyApplicationsSaga()]);
}
